import { useTranslation } from "react-i18next";
import { Globe, Check } from "lucide-react";
import { useState, useRef, useEffect } from "react";
import { SUPPORTED_LANGS } from "../i18n";

export default function LanguageSwitcher({ variant = "default" }) {
  const { i18n, t } = useTranslation();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", onClickOutside);
    return () => document.removeEventListener("mousedown", onClickOutside);
  }, []);

  const current = SUPPORTED_LANGS.find((l) => l.code === i18n.language) || SUPPORTED_LANGS[0];

  const change = (code) => {
    i18n.changeLanguage(code);
    setOpen(false);
  };

  return (
    <div className="relative" ref={ref}>
      <button onClick={() => setOpen((o) => !o)} data-testid="language-switcher"
        className={`inline-flex items-center gap-1.5 rounded-lg px-2.5 py-1.5 text-sm transition ${
          variant === "minimal"
            ? "text-[#475569] hover:bg-[#FFF7ED]"
            : "border border-[#FED7AA] bg-white hover:bg-[#FFF7ED] text-[#0F172A]"
        }`}>
        <span className="text-base leading-none">{current.flag}</span>
        <span className="font-medium uppercase text-xs tracking-wider">{current.code}</span>
      </button>
      {open && (
        <div className="absolute right-0 mt-2 w-48 bg-white rounded-xl border border-[#E2E8F0] shadow-lg overflow-hidden z-50"
             data-testid="language-menu">
          <div className="px-3 py-2 text-[10px] uppercase tracking-wider text-[#94A3B8] font-semibold border-b border-[#F1F5F9]">
            <Globe className="w-3 h-3 inline mr-1" /> {t("language.label", "Idioma")}
          </div>
          {SUPPORTED_LANGS.map((lang) => (
            <button key={lang.code} onClick={() => change(lang.code)}
              data-testid={`lang-${lang.code}`}
              className="w-full px-3 py-2.5 flex items-center justify-between text-left text-sm hover:bg-[#FFF7ED] transition">
              <span className="flex items-center gap-2">
                <span className="text-base">{lang.flag}</span>
                <span>{t(`language.${lang.code}`, lang.code.toUpperCase())}</span>
              </span>
              {lang.code === current.code && <Check className="w-4 h-4 text-[#E78938]" />}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
